import { render } from "./ReferenceEdit.vue?vue&type=template&id=612c4a40"
import script from "./ReferenceEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/reference/ReferenceEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "612c4a40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('612c4a40', __exports__)) {
    api.reload('612c4a40', __exports__)
  }
  
  module.hot.accept("./ReferenceEdit.vue?vue&type=template&id=612c4a40", () => {
    api.rerender('612c4a40', render)
  })

}


export default __exports__